import { PASSENGER_CATEGORY_TYPES } from '../../constants/passengerCategories';

const FIRST_ROW_RESTRICTED_CATEGORIES = [
  PASSENGER_CATEGORY_TYPES.OLDER,
  PASSENGER_CATEGORY_TYPES.MINOR,
];

const normalize = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase();

const lineRestrictsFirstRow = (line, restrictedTransporters) => {
  if (!Array.isArray(restrictedTransporters) || !restrictedTransporters.length) return false;
  const transporterName = normalize(line?.transporterName);
  if (!transporterName) return false;
  return restrictedTransporters.some((t) => normalize(t) === transporterName);
};

// Layout shape: layout[deck][row][space], where row[0] is the front-most row.
const isSeatInFirstRow = (seatNumber, layout) => {
  if (seatNumber == null || !Array.isArray(layout)) return false;
  return layout.some((deck) => {
    const firstRow = Array.isArray(deck) ? deck[0] : null;
    if (!Array.isArray(firstRow)) return false;
    return firstRow.some((space) => space && String(space.number) === String(seatNumber));
  });
};

/**
 * Returns the passenger category types that should be disabled for a given
 * seat, based on the line's first-row restrictions.
 * @param {object} params
 * @param {string|number} params.seatNumber - Seat number assigned to the passenger.
 * @param {Array} params.layout - Trip seat layout (purchase.{departs,returns}.layout).
 * @param {object} params.line - Line/operator of the trip.
 * @param {string[]} params.restrictedTransporters - transporterNames that apply
 *   the rule (from features.FIRST_ROW_RESTRICTED_TRANSPORTERS).
 * @returns {string[]} Restricted category types.
 */
const getFirstRowRestrictedCategories = ({ seatNumber, layout, line, restrictedTransporters }) => {
  if (!lineRestrictsFirstRow(line, restrictedTransporters)) return [];
  if (!isSeatInFirstRow(seatNumber, layout)) return [];
  return FIRST_ROW_RESTRICTED_CATEGORIES;
};

export default getFirstRowRestrictedCategories;
